import {
  Button,
  useTheme
} from '@mui/material';
import { CustomIcon } from 'modules/components/layer00';
import {
  InviteNonUserModal,
  InvitePersonModal
} from 'modules/components/layer17';
import { ActivityHeaderSectionWithSearchLayout } from 'modules/components/layer32';
import React, { useState } from 'react';



export type TeamHeaderSectionProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: TeamHeaderSectionProps) => {

  return (
    <ActivityHeaderSectionWithSearchLayout.FC
      title='Team'
      subtitle=''
      actionButtons={<ActionButtonsGroup />}
      searchBar={<></>}
    />
  );
};


type ActionButtonsGroup = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
const ActionButtonsGroup = (props: ActionButtonsGroup) => {
  const theme = useTheme();
  const [
    isVisible,
    setIsVisible
  ] = useState(false);
  const [
    isAddNonUserVisible,
    setIsAddNonUserVisible
  ] = useState(false);

  return (
    <>
      {isVisible && (
        <InvitePersonModal.FC
          id=''
          isVisible={isVisible}
          handleClose={() => setIsVisible(() => false)}
        />
      )}
      {isAddNonUserVisible && (
        <InviteNonUserModal.FC
          id=''
          isVisible={isAddNonUserVisible}
          handleClose={() => setIsAddNonUserVisible(() => false)}
        />
      )}
      <Button
        variant='contained'
        color='primary'
        onClick={() => setIsAddNonUserVisible(() => true)}
        startIcon={(
          <CustomIcon.large.FC
            icon='PLUS'
            stroke={theme.palette.primary.contrastText}
          />
        )}
      >
        Add Person
      </Button>
      <Button
        variant='contained'
        color='primary'
        onClick={() => setIsVisible(() => true)}
        startIcon={(
          <CustomIcon.large.FC
            icon='PLUS'
            stroke={theme.palette.primary.contrastText}
          />
        )}
      >
        Invite User
      </Button>

    </>
  );
};
